const RANGES = [
    { min: 0, max: 20, title: 'Very Low' },
    { min: 21, max: 40, title: 'Low' },
    { min: 41, max: 60, title: 'Medium' },
    { min: 61, max: 80, title: 'High' },
    { min: 81, max: 100, title: 'Very High' },
];

export default RANGES;
